var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLinkedin(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 31,
    viewBox: "0 0 31 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_75_154)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.74 22.09V8.15C29.74 3.92502 26.315 0.5 22.09 0.5L8.14999 0.5C3.92501 0.5 0.49999 3.92502 0.49999 8.15V22.09C0.49999 26.315 3.92501 29.74 8.14999 29.74H22.09C26.315 29.74 29.74 26.315 29.74 22.09Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.99002 12.4H11.82V21.5H8.99002V12.4ZM10.41 7.88C11.32 7.88 12.05 8.61001 12.05 9.52001C12.05 10.43 11.32 11.16 10.41 11.16C9.50002 11.16 8.77002 10.42 8.77002 9.52001C8.77002 8.62001 9.50002 7.88 10.41 7.88Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.6001 12.4H16.3101V13.64H16.3501C16.7301 12.92 17.6501 12.17 19.0301 12.17C21.8901 12.17 22.4201 14.05 22.4201 16.5V21.49H19.5901V17.07C19.5901 16.01 19.5701 14.66 18.1201 14.66C16.6701 14.66 16.4201 15.81 16.4201 17V21.5H13.5901V12.4H13.6001Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_75_154"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30.24,
    height: 30.24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.bf4fe8c6ac24283346c174f53d24e01f.svg";
export { ForwardRef as ReactComponent };